/**
 * @generated SignedSource<<7cc91628f0d60c220ab02ce273534c64>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RemoveOrderItemButton_OrderItemFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "RemoveOrderItemButton_OrderItemFragment";
};
export type RemoveOrderItemButton_OrderItemFragment$key = {
  readonly " $data"?: RemoveOrderItemButton_OrderItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RemoveOrderItemButton_OrderItemFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RemoveOrderItemButton_OrderItemFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "OrderItem",
  "abstractKey": null
};

(node as any).hash = "6e1325f2811622a1313e680247fe93cb";

export default node;
